import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-help-content',
  templateUrl: './help-content.page.html',
  styleUrls: ['./help-content.page.scss'],
})
export class HelpContentPage implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }
  gotopage(pagename) {
    
    window.open(pagename, '_self');
    // this.router.navigate([pagename])
  }
}
